// 引入 buffer polyfill
import { Buffer } from 'buffer';
window.Buffer = window.Buffer || Buffer;

import  process from 'process';
window.process = window.process || process;


import AxiosPlugin from '@/utils/plugin/axios-plugin';
import * as echarts from 'echarts';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import JSEncrypt from "jsencrypt"; //引入模块
import less from 'less';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import ExtendPrototype from './utils/ExtendPrototype';
import htmlToPdf from './utils/htmlToPdf';

import * as filters from './utils/filter'


import enlocale from 'element-ui/lib/locale/lang/en';
import zhlocale from 'element-ui/lib/locale/lang/zh-CN';

import Chart from 'chart.js/auto';
// import annotationPlugin from 'chartjs-plugin-annotation';
// Chart.register(annotationPlugin);



Vue.prototype.$chart = Chart;

// import 'font-awesome/css/font-awesome.min.css'
var locale = (localStorage.getItem('user_lang') == 'en' || Globals.DefaultLanguage == 'en') ? enlocale : zhlocale
Vue.use(less)
Vue.use(ElementUI, { locale, size: 'small' })
Vue.use(echarts)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(AxiosPlugin)
Vue.prototype.$baseConfig = Globals;
Vue.use(ExtendPrototype)
Vue.use(htmlToPdf)

Vue.use(VueI18n)
const i18n = new VueI18n({
  //locale: localStorage.getItem('user_lang') || 'zh', // 语言标识
  locale: localStorage.getItem('user_lang') || Globals.DefaultLanguage, // 语言标识
  messages: {
    'zh': require('../public/language/zh'),
    'en': require('../public/language/en')
  },
  silentTranslationWarn: true
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

import navigationBar from "../src/components/content/maintabber/navigationBar.vue";
Vue.component("nav-bar", navigationBar)

Vue.config.errorHandler = (err, vm, info) => {
  console.error('全局捕获:', err);
  return false; // 阻止错误继续向上传播
};

ElementUI.Dialog.props.closeOnClickModal.default = false; // 修改 el-dialog 默认点击遮照为不关闭

Vue.prototype.$jsEncrypt = JSEncrypt; //配置全局变量
